import { TimeSpanPeriods } from '@shared/utils/Time/TimeSpan';
import { DataCache } from '../DataCache';
import { BrowserUtils } from '../UtilsClasses/BrowserUtils';
export class HistoricalBM {
    constructor() {
        this.ID = null;
        this.TimeStamp = null; // new Date() object
        this.ProductID = null;
        this.Subject = null;
        this.Message = null;
        this.IsUnread = null;
        this.IsSelected = null;
        this.ShowPopUp = null;
        this.ResponseCases = null;
        this.CustomButtons = null;
        this.ClusterNode = null; // #111311
        this.DisplayMethod = null;
        this.colorHEXstr = null;
    }
    UpdateByBM(msg) {
        if (isNullOrUndefined(msg)) {
            return;
        }
        this.ID = msg.ID;
        this.TimeStamp = msg.Date;
        this.ProductID = msg.ProductID;
        this.Subject = msg.Name;
        this.Message = msg.Text;
        this.IsUnread = msg.IsUnread;
        this.ShowPopUp = msg.ShowPopUp;
        this.ResponseCases = msg.ResponseCases;
        this.DisplayMethod = msg.DisplayMethod;
        this.CustomButtons = msg.CustomButtons;
        this.ClusterNode = msg.ClusterNode;
    }
    UpdateByInfo(info) {
        var _a;
        if (isNullOrUndefined(info)) {
            return;
        }
        this.ID = info.ID;
        this.TimeStamp = info.TimeStamp;
        this.ProductID = info.ProductID;
        this.Subject = info.Subject;
        this.Message = info.Message;
        this.IsUnread = info.IsUnread;
        this.ShowPopUp = (_a = info.ShowPopUp) !== null && _a !== void 0 ? _a : true;
        this.ResponseCases = info.ResponseCases;
        this.DisplayMethod = info.DisplayMethod;
        this.CustomButtons = info.CustomButtons;
        this.ClusterNode = info.ClusterNode;
    }
    get Date() {
        let result = '';
        const ts = this.TimeStamp;
        if (ts) {
            const today = new Date();
            if (ts.getDate() == today.getDate() &&
                Math.abs(ts.getTime() - today.getTime()) <= TimeSpanPeriods.TicksPerDay) {
                result = ts.toLocaleTimeString();
            }
            else {
                result = ts.toLocaleDateString();
            }
        }
        return result;
    }
    get Title() {
        return this.Subject;
    }
    get Text() {
        return this.Message;
    }
    get OnlyText() {
        return BrowserUtils.RemoveHTMLTags(this.Message);
    }
    get Category() {
        if (this._category) {
            return this._category;
        }
        const product = DataCache.EntitlementManager.ProductsCache[this.ProductID];
        if (product) {
            this._category = product.Name;
            return this._category;
        }
        return '';
    }
    get InstanceOfHistoricalBM() {
        return true;
    }
}
